import { render, staticRenderFns } from "./YxOrderChoose.vue?vue&type=template&id=041fef02&scoped=true"
import script from "./YxOrderChoose.vue?vue&type=script&lang=js"
export * from "./YxOrderChoose.vue?vue&type=script&lang=js"
import style0 from "./YxOrderChoose.vue?vue&type=style&index=0&id=041fef02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fef02",
  null
  
)

export default component.exports